import { useEffect, useRef } from 'react';
import addIngridAttributes from '@activebrands/core-web/libs/centra/add-ingrid-attributes';
import { addBasketInformation } from '@activebrands/core-web/state/basket/actions';
import { useTypedDispatch, useTypedSelector } from '@activebrands/core-web/state/store';

const INGRID_SITE_TAG = process.env.REACT_APP_INGRID_SITE_TAG || '';

interface UseBasketTypeUpdateInput {
    basketType: string;
    currentCheckoutStep: number;
    deliveryStep: number;
}

const useBasketTypeUpdate = ({ basketType, currentCheckoutStep, deliveryStep }: UseBasketTypeUpdateInput) => {
    const isMounted = useRef(false);

    const dispatch = useTypedDispatch();
    const locale = useTypedSelector(state => state.application.locale);
    const auth = useTypedSelector(state => state.auth) || {};

    const userTags = auth.user?.tags || [];

    // If the user removes a product from the basket causing 'basketType' to change, we need
    // to update the basket information Otherwise the shipping options will not be updated.
    useEffect(() => {
        if (isMounted.current) {
            if (currentCheckoutStep === deliveryStep) {
                // It seems to be difficult to let TEAMMIX and TEAM tags override the ACT tag in Ingrid.
                // Therefore we remove the ACT tag if the user has TEAMMIX or TEAM tags.
                const filteredUserTags =
                    basketType === 'INLINE' ? userTags : userTags.filter(tag => tag.name !== 'ACT');

                const newBasketData = {
                    additionalFields: {
                        ingridAttributes: addIngridAttributes(
                            filteredUserTags,
                            auth.isAuthenticated,
                            INGRID_SITE_TAG,
                            locale
                        ),
                    },
                };

                if (basketType) {
                    newBasketData.additionalFields.ingridAttributes.push(basketType);
                }

                dispatch(addBasketInformation(newBasketData) as any);
            }
        } else {
            isMounted.current = true;
        }
    }, [basketType]);
};

export default useBasketTypeUpdate;
